/**
 * Configuration déclarative pour l'entité Vehicle
 * Source unique de vérité pour tous les champs de Vehicle
 */

import type { Vehicle } from '../../types/vehicle';
import { defineEntityConfig } from '../../lib/entity-config';
import { parseFrenchDate } from '../../lib/csv-import';

export const VEHICLE_CONFIG = defineEntityConfig<Vehicle>({
  entityName: 'véhicule',
  entityNamePlural: 'véhicules',

  fields: {
    registration: {
      key: 'registration',
      label: 'Immatriculation',
      type: 'text',
      required: true,
      unique: true,
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 150,
      importValidation: (value) => {
        if (typeof value !== 'string') return "L'immatriculation doit être une chaîne";
        if (value.length < 2) return "L'immatriculation doit contenir au moins 2 caractères";
        return true;
      },
    },

    crew_id: {
      key: 'crew_id',
      label: 'Équipage affecté',
      type: 'relation',
      sortable: false,
      showInTable: true,
      showInFilters: false,
      exportable: true,
      importable: false, // Trop complexe pour import initial
      // Le transformer sera fourni dynamiquement avec accès à crews
    },

    circulation_date: {
      key: 'circulation_date',
      label: 'Date de mise en circulation',
      type: 'date',
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 200,
      description: 'Format: JJ/MM/AAAA',
      exportTransform: (value: string) =>
        value ? new Date(value).toLocaleDateString('fr-FR') : '',
      importTransform: (value: string) => parseFrenchDate(value),
    },

    notes: {
      key: 'notes',
      label: 'Notes',
      type: 'text',
      sortable: false,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
    },

    owner: {
      key: 'owner',
      label: 'Propriétaire',
      type: 'text',
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 200,
    },
    // 00270 (recette 4L 22/09, retour 29) : « le code moteur doit apparaître
    // sur la fiche véhicule ». Reporté du bulletin, corrigeable par le staff.
    engine_code: {
      key: 'engine_code',
      label: 'Code moteur',
      type: 'text',
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 160,
    },
  },
});
